import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../../layoutPages/components/PageTitle';
import { CourseTab } from '../menuTab';
import { HaveImage, Paragraph } from '../../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../../layoutPages/defaultSetting';
import { DottedList } from '../../../layoutPages/containers/DottedList';
import { MainCard } from '../../../layoutPages/components/MainCard';
import { chiMenuData } from '../../../data/SubjectMenu/chiMenuData';

export function PageChiObjectives() {

    const isPc = useMediaQuery('(min-width:600px)');

    let dottedListData = [
        "提高讀寫聽說能力、思維能力、審美能力和自學能力",
        "培養語文學習的興趣、良好的語文學習態度和習慣",
        "培養審美情趣，陶冶性情",
        "培養品德，加強對社群的責任感",
        "體認中華文化，培養對國家、民族的感情"
    ];


    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <Grid item xs={11} sm={10} >
                <PageTitle title='中國語文 | 課程目標' size='h3' subtitle={{ title: 'CURRICULUM OBJECTIVES', size: 'h5' }} />
                <CourseTab data={chiMenuData}/>
                <MainCard src="http://www.pkps.edu.hk/img/teachplan/chi/objectives/top.jpg" noImgPopup={true} />

                <Paragraph 
                            data={[
                                <DottedList data={dottedListData} />
                            ]}
                            haveImage={{
                                images:[{ src:"http://www.pkps.edu.hk/img/teachplan/chi/objectives/obj1.jpg" }],
                                position:"right",
                                imageHeight: "550px",
                            }}
                        />

                <MainCard sx={{mt:3}} imgHeight="450px" src="http://www.pkps.edu.hk/img/teachplan/chi/objectives/bottom.jpg" />
            </Grid>
        </Grid>
    )
}
